// extracted by mini-css-extract-plugin
module.exports = {"container":"audit-table_container__2XiYq","heading":"audit-table_heading__l1Fr8","table":"audit-table_table__12xf5"};